const $ = require('jquery');

const GenericLottie = {
	init() {
		this.$el = $('.js-lottie-anim-init');
		if (this.$el.length > 0) {
			this.setup();
		}
	},
	setup() {
		this.injectGenericLottiePlayer();
		this.$el.each(this.elSetup.bind(this));
	},
	elSetup(i, el) {
		const $$ = $(el);

		$( $$ ).each(function() {
			if ($$.hasClass('js-lottie-anim-init')) {
				const $generic_player = $('lottie-player');
				this.append($generic_player);
				this.generic_player = $generic_player.get(0);
			}

		});
	},
	injectGenericLottiePlayer() {

		this.lottieLoaded();

		//loading via require (require('@lottiefiles/lottie-player')) statement in main.js
		// const tag = 'script';
		// const s = document.createElement(tag);
		// s.type = 'text/javascript';
		// s.async = 1;
		//s.addEventListener('load', () => { this.lottieLoaded(); });
		// s.src = 'https://unpkg.com/@lottiefiles/lottie-player@0.4.0/dist/lottie-player.js';
		// document.getElementsByTagName(tag)[0].parentNode.appendChild(s);
	},
	lottieLoaded() {
		if ( window.IntersectionObserver ) {
			const config = {
				root: null,
				rootMargin: '0px',
				threshold: [0.1, 0.5, 0.7, 1]
			};

			//let previousY = 0;
			let previousRatio = 0;


			let observer = new IntersectionObserver(function (entries) {
				entries.forEach(entry => {
					const intersect_ratio_value = 0.50;
					//const currentY = entry.boundingClientRect.y;
					const currentRatio = entry.intersectionRatio;
					//const isIntersecting = entry.isIntersecting;
					const element = entry.target;

					element.classList.remove('outview-top', 'inview-top', 'inview-bottom', 'outview-bottom');
					// Scrolling up
					if (currentRatio >= intersect_ratio_value) {
						const className = (currentRatio >= previousRatio) ? 'inview-top' : 'outview-top';
						element.classList.add(className);
						element.play();
					} else {
						const className = (currentRatio <= previousRatio) ? 'outview-bottom' : 'inview-bottom';
						element.classList.add(className);
						element.pause();
					}

					//previousY = currentY;
					previousRatio = currentRatio;
				});
			}, config);

			const images = document.querySelectorAll('.js-lottie-anim-init');
			images.forEach(image => {
				observer.observe(image);
			});
		} else {
			// Play immediately if we are in an older browser
			this.generic_player.play();
		}
	}
};
$(GenericLottie.init.bind(GenericLottie));
